export const Svg = ({
  data,
  ...rest
// @ts-ignore
}: { data: StaticImageData } & React.HTMLAttributes<SVGElement>) => {
  return (
    <svg
      viewBox={`0 0 ${data.width} ${data.height}`}
      width={data.width}
      height={data.height}
      {...rest}
    >
      <use href={`${data.src}#root`} />
    </svg>
  );
};
